var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 18,
    fill: "#5D67C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#6CC13C",
    strokeWidth: 0.2,
    d: "M18.5 18.997a1.183 1.183 0 0 0-2.02.837.983.983 0 1 1-1.966 0 3.15 3.15 0 1 1 6.3 0 .983.983 0 1 1-1.967 0c0-.314-.124-.615-.346-.837ZM24.109 17.607a3.15 3.15 0 0 1 5.377 2.227.983.983 0 1 1-1.967 0 1.184 1.184 0 0 0-2.366 0 .983.983 0 1 1-1.967 0c0-.835.332-1.637.923-2.227ZM25.005 25.192l.002-.002.605-.607h.01l.03-.029a.984.984 0 0 1 1.391 1.392l-.636.633a6.213 6.213 0 0 1-8.796 0l-.637-.633a.984.984 0 1 1 1.392-1.392l.633.637.002.001a4.353 4.353 0 0 0 6.004 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileBlue);
export default __webpack_public_path__ + "static/media/smile-blue.0df8ae0f3f341621548fa0023e140a0f.svg";
export { ForwardRef as ReactComponent };